import React from 'react'
import { AttachmentLink, Button, KennoFile } from '@pandiafi/design-system'
import { DetailRow } from '@pandiafi/components'
import { useTranslation } from 'react-i18next'

import { Section } from '../../components'

import { CardTitleBand } from 'components/CardTitleBand/CardTitleBand'

interface FormValues {
  title: string
  description: string
  files: KennoFile[]
  email: string
  phoneNumber: string
}

interface QuestionPreviewProps {
  formValues: FormValues
  isSubmitting: boolean
  submit: () => void
  cancel: () => void
}

export const QuestionPreview: React.FC<QuestionPreviewProps> = ({
  formValues,
  isSubmitting,
  submit,
  cancel,
}) => {
  const { t } = useTranslation(['common', 'question'])

  const { title, description, files, email, phoneNumber } = formValues

  const handleCancel = () => {
    cancel()
  }

  const handleSubmit = () => {
    submit()
  }

  return (
    <>
      <CardTitleBand>{t('question:headings.preview')}</CardTitleBand>
      <Section className="mb-12">
        <DetailRow>
          <DetailRow.Item title={t('question:labels.email')}>
            {email}
          </DetailRow.Item>
          <DetailRow.Item title={t('question:labels.phoneNumber')}>
            {phoneNumber}
          </DetailRow.Item>
          <DetailRow.Item title={t('question:labels.title')} preLine>
            {title}
          </DetailRow.Item>
          <DetailRow.Item title={t('question:labels.description')} preLine>
            {description}
          </DetailRow.Item>
          {files && files.length > 0 && (
            <DetailRow.Item title={t('question:labels.files')}>
              {files.map((file) => (
                <AttachmentLink
                  key={file.uuid || file.fileName}
                  href={file._objectUrl}
                  text={file.metadata?.originalFileName ?? file.fileName}
                  icon={file.fileType === 'image' ? 'image' : 'file'}
                  target="_blank"
                  className="break-all"
                />
              ))}
            </DetailRow.Item>
          )}
        </DetailRow>
      </Section>

      <div className="flex flex-col sm:flex-row gap-4 pt-4 justify-end">
        <Button
          variant="secondary"
          onClick={handleCancel}
          className="order-2 sm:order-1"
          disabled={isSubmitting}
        >
          {t('question:actions.edit')}
        </Button>
        <Button
          onClick={handleSubmit}
          className="order-1 sm:order-2"
          disabled={isSubmitting}
          loading={isSubmitting}
        >
          {t('question:actions.submit')}
        </Button>
      </div>
    </>
  )
}
